(function () {

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire164e"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire164e"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("6IT3i", function(module, exports) {

$parcel$export(module.exports, "register", function () { return $4e518e571360fc84$export$6503ec6e8aabbaf; }, function (v) { return $4e518e571360fc84$export$6503ec6e8aabbaf = v; });
$parcel$export(module.exports, "resolve", function () { return $4e518e571360fc84$export$f7ad0328861e2f03; }, function (v) { return $4e518e571360fc84$export$f7ad0328861e2f03 = v; });
var $4e518e571360fc84$export$6503ec6e8aabbaf;
var $4e518e571360fc84$export$f7ad0328861e2f03;
"use strict";
var $4e518e571360fc84$var$mapping = new Map();
function $4e518e571360fc84$var$register(baseUrl, manifest) {
    for(var i = 0; i < manifest.length - 1; i += 2)$4e518e571360fc84$var$mapping.set(manifest[i], {
        baseUrl: baseUrl,
        path: manifest[i + 1]
    });
}
function $4e518e571360fc84$var$resolve(id) {
    var resolved = $4e518e571360fc84$var$mapping.get(id);
    if (resolved == null) throw new Error("Could not resolve bundle with id " + id);
    return new URL(resolved.path, resolved.baseUrl).toString();
}
$4e518e571360fc84$export$6503ec6e8aabbaf = $4e518e571360fc84$var$register;
$4e518e571360fc84$export$f7ad0328861e2f03 = $4e518e571360fc84$var$resolve;

});

parcelRegister("4vTas", function(module, exports) {

$parcel$export(module.exports, "getBundleURL", function () { return $3494d9d0ce7a7ef9$export$bdfd709ae4826697; }, function (v) { return $3494d9d0ce7a7ef9$export$bdfd709ae4826697 = v; });
var $3494d9d0ce7a7ef9$export$bdfd709ae4826697;
var $3494d9d0ce7a7ef9$export$c9e73fbda7da57b6;
var $3494d9d0ce7a7ef9$export$5a759dc7a1cfb72a;
"use strict";
var $3494d9d0ce7a7ef9$var$bundleURL = {};
function $3494d9d0ce7a7ef9$var$getBundleURLCached(id) {
    var value = $3494d9d0ce7a7ef9$var$bundleURL[id];
    if (!value) {
        value = $3494d9d0ce7a7ef9$var$getBundleURL();
        $3494d9d0ce7a7ef9$var$bundleURL[id] = value;
    }
    return value;
}
function $3494d9d0ce7a7ef9$var$getBundleURL() {
    try {
        throw new Error();
    } catch (err) {
        var matches = ("" + err.stack).match(/(https?|file|ftp|(chrome|moz|safari-web)-extension):\/\/[^)\n]+/g);
        if (matches) // The first two stack frames will be this function and getBundleURLCached.
        // Use the 3rd one, which will be a runtime in the original bundle.
        return $3494d9d0ce7a7ef9$var$getBaseURL(matches[2]);
    }
    return "/";
}
function $3494d9d0ce7a7ef9$var$getBaseURL(url) {
    return ("" + url).replace(/^((?:https?|file|ftp|(chrome|moz|safari-web)-extension):\/\/.+)\/[^/]+$/, "$1") + "/";
}
// TODO: Replace uses with `new URL(url).origin` when ie11 is no longer supported.
function $3494d9d0ce7a7ef9$var$getOrigin(url) {
    var matches = ("" + url).match(/(https?|file|ftp|(chrome|moz|safari-web)-extension):\/\/[^/]+/);
    if (!matches) throw new Error("Origin not found");
    return matches[0];
}
$3494d9d0ce7a7ef9$export$bdfd709ae4826697 = $3494d9d0ce7a7ef9$var$getBundleURLCached;
$3494d9d0ce7a7ef9$export$c9e73fbda7da57b6 = $3494d9d0ce7a7ef9$var$getBaseURL;
$3494d9d0ce7a7ef9$export$5a759dc7a1cfb72a = $3494d9d0ce7a7ef9$var$getOrigin;

});

var $99b3620bf5de54a4$exports = {};


(parcelRequire("6IT3i")).register((parcelRequire("4vTas")).getBundleURL("hpNCx"), JSON.parse('["hpNCx","index.38761d3c.js","8zjyc","Grocery.3f1e3f22.js"]'));

})();
//# sourceMappingURL=index.runtime.94498a9c.js.map
